import React, { FC } from 'react';
import { Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { ContactCheckIcon } from 'assets/svgs';

interface ContactDescriptionProps {
  title?: string;
  firstText?: string;
  listItems?: string[];
}

const useStyles = makeStyles((theme: Theme) => {
  return {
    title: {
      fontSize: 24,
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    text: {
      fontSize: 18,
      fontWeight: 400,
      color: theme.palette.text.primary,
      marginTop: 26,
      paddingRight: 16,
      marginBottom: 12,
    },
    icon: {
      marginTop: 22,
    },
    listItem: {
      fontSize: 18,
      fontWeight: 600,
      color: theme.palette.text.primary,
      marginTop: 20,
    },
  };
});
const ContactDescription: FC<ContactDescriptionProps> = ({ title, firstText, listItems = [] }) => {
  const classes = useStyles();
  return (
    <>
      <Typography className={classes.title}>{title}</Typography>
      <Typography className={classes.text}>{firstText}</Typography>
      {listItems.map((child, index) => (
        <Grid container key={index}>
          <Grid xs={1} sm={1} md={1} lg={1} className={classes.icon} item>
            <ContactCheckIcon />
          </Grid>
          <Grid xs={11} sm={11} md={11} lg={11} item>
            <Typography className={classes.listItem}>{child}</Typography>
          </Grid>
        </Grid>
      ))}
    </>
  );
};

export default ContactDescription;
